<template>
  <MapPopup
      icon="icon-object"
      :title="object?.name"
      :data="object?.popup?.main"
      :lat="object?.lat"
      :lng="object?.lng"
      @close="emit('close')"
  >
    <div class="map-popup__row">
      <span class="label">
        {{ $t('front.address') }}
      </span>

      <Address v-if="object"
               full
               :lat="object?.lat"
               :lng="object?.lng"
      >
        <template #default="{address}">
          <span class="value">
            {{ address }}
          </span>
        </template>
      </Address>
    </div>
  </MapPopup>
</template>
<script setup>
import MapPopup from "@/js/Components/MapPopup/Popup.vue";
import Address from "@/js/Elements/Address.vue";
import {computed, onBeforeUnmount, watch} from "vue";
import {useStore} from "vuex";

const store = useStore();
const props = defineProps({
  id: Number,
});
const emit = defineEmits(['close']);
const object = computed(() => store.getters['camera-media/find'](props.id));
const units = computed(() => store.getters['settings/units']);
const iso = computed(() => store.getters['app/iso']);
</script>
